<div id="wrapper" class="wrapper clearfix">
    <router-outlet></router-outlet>
    <div id="back-to-top" class="backtop"><fa-icon [icon]="faArrUp"></fa-icon></div>
</div>
